import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import axios from "axios";
import { Link } from "react-router-dom";

export default function CategorySlider() {
  const baseURL = "https://ecommerce.routemisr.com"; // or 'https://route-ecommerce-app.vercel.app'

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 5,
    slidesToScroll: 4,
  };

  const [categorySlide, setcategorySlide] = useState(null);

  async function getCategories() {
    let { data } = await axios.get(`${baseURL}/api/v1/categories`);
    setcategorySlide(data.data);
  }

  useEffect(() => {
    getCategories();
  }, []);

  return (
    <>
      <div>
        <h2 className=" h4 fw-bold mb-3">Shop Popular Categories</h2>
        <Slider {...settings}>
          {categorySlide?.map((cat, idx) => (
            <div key={idx} className="cursor-pointer">
              <Link to={`/categorydetails/${cat._id}`}>
                <img
                  className="w-100"
                  height={250}
                  src={cat.image}
                  alt={cat.name}
                />
                <h2 className="h6 font-sm fw-bold pt-2 text-center">
                  {cat.name}
                </h2>
              </Link>
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
}
